import { useParams } from 'react-router-dom';
import ClienteForm from './ClienteForm';

const EditarCliente = () => {
  const { id } = useParams();
  return (
    <div className="clientes-page">
      <div className="clientes-header">
        <h1>Editar Cliente</h1>
      </div>
      <ClienteForm mode="edit" clienteId={id} />
    </div>
  );
};

export default EditarCliente;
